import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fmt = {
  money: (n, ccy = "$") => `${ccy}${Number(n ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
  pct: (n) => `${Number(n ?? 0).toFixed(2)}%`,
  int: (n) => Number(n ?? 0).toLocaleString(),
  signed: (n) => `${n >= 0 ? "+" : ""}${Number(n ?? 0).toFixed(2)}`,
  num: (n) => Number(n ?? 0).toFixed(2),
};

export const STATUS_META = {
  champion: { label: "Champion", color: "#D6FF38", bg: "rgba(214,255,56,0.10)", border: "rgba(214,255,56,0.25)" },
  elite:    { label: "Elite",    color: "#60A5FA", bg: "rgba(96,165,250,0.10)",  border: "rgba(96,165,250,0.25)" },
  basic:    { label: "Basic",    color: "#22C55E", bg: "rgba(34,197,94,0.10)",    border: "rgba(34,197,94,0.25)" },
  testing:  { label: "Testing",  color: "#F97316", bg: "rgba(249,115,22,0.10)",   border: "rgba(249,115,22,0.30)" },
  graveyard:{ label: "Graveyard",color: "#FF4D4D", bg: "rgba(255,77,77,0.10)",    border: "rgba(255,77,77,0.25)" },
};

// Tier priority for sorting: higher = better. Used everywhere we need to
// rank bots so a Champion always sits above an Elite, an Elite above a Basic,
// etc, regardless of raw growth %.
export const TIER_RANK = { champion: 4, elite: 3, basic: 2, testing: 1, graveyard: 0 };
export const rankByTier = (a, b) =>
  (TIER_RANK[b?.status] ?? 0) - (TIER_RANK[a?.status] ?? 0)
  || (Number(b?.growth_pct) || 0) - (Number(a?.growth_pct) || 0);
